import React, { useState } from "react";
import "./styles/TableauAnnexe3.css";

function TableauAnnexe3({
  formData,
  setFormData,
  handleCheckboxChangeTabeleau,
}) {
  const [visiblePeriodicity, setVisiblePeriodicity] = useState({});

  const handleMouseEnter = (...keys) => {
    setVisiblePeriodicity((prev) => {
      const updated = { ...prev };
      keys.forEach((key) => {
        updated[key] = true;
      });
      return updated;
    });
  };

  const handleMouseLeave = (...keys) => {
    setVisiblePeriodicity((prev) => {
      const updated = { ...prev };
      keys.forEach((key) => {
        updated[key] = false;
      });
      return updated;
    });
  };

  return (
    <div className="Annexe3">
      <table style={{ borderCollapse: "collapse", width: "100%" }}>
        <thead>
          <tr>
            <th
              style={{
                border: "1px solid black",
                padding: "8px",
                textAlign: "left",
              }}
            >
              Tableau de répartition des obligations respectives
            </th>
            <th
              style={{
                border: "1px solid black",
                padding: "8px",
                textAlign: "center",
              }}
            >
              <p>Périodicité</p>
            </th>
            <th
              style={{
                border: "1px solid black",
                padding: "8px",
                textAlign: "center",
              }}
            >
              Expert-comptable
            </th>
            <th
              style={{
                border: "1px solid black",
                padding: "8px",
                textAlign: "center",
              }}
            >
              Client
            </th>
          </tr>
        </thead>
        <tbody>
          <tr style={{ fontWeight: "bold" }}>Constitution du dossier</tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Collecte et transmission par écrit (courriel, fax, courrier){" "}
              <br /> des éléments relatifs à l’entité et aux salariés <br />{" "}
              (situation civile, adresses, etc.)
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("cet_pa3")}
              onMouseLeave={() => handleMouseLeave("cet_pa3")}
            >
              {visiblePeriodicity["cet_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="cet_pa3"
                        value={value}
                        checked={formData.cet_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.cet_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            cet_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.cet_pa3) && formData.cet_pa3.length > 0
                  ? formData.cet_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cet_ec_a3"
                checked={formData.cet_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cet_c_a3"
                checked={formData.cet_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Déclaration à la CNIL si celle-ci s’avère obligatoire
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("cnil_pa3")}
              onMouseLeave={() => handleMouseLeave("cnil_pa3")}
            >
              {visiblePeriodicity["cnil_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="cnil_pa3"
                        value={value}
                        checked={formData.cnil_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.cnil_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            cnil_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.cnil_pa3) &&
                formData.cnil_pa3.length > 0
                  ? formData.cnil_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cnil_ec_a3"
                checked={formData.cnil_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cnil_c_a3"
                checked={formData.cnil_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Prise de connaissance du réglementaire de paie <br /> dans le
              cadre de la constitution du dossier
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("pdc_pa3")}
              onMouseLeave={() => handleMouseLeave("pdc_pa3")}
            >
              {visiblePeriodicity["pdc_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="pdc_pa3"
                        value={value}
                        checked={formData.pdc_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.pdc_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            pdc_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.pdc_pa3) && formData.pdc_pa3.length > 0
                  ? formData.pdc_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="pdc_ec_a3"
                checked={formData.pdc_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="pdc_c_a3"
                checked={formData.pdc_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Création informatique de l’entité/établissements
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("cid_pa3")}
              onMouseLeave={() => handleMouseLeave("cid_pa3")}
            >
              {visiblePeriodicity["cid_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="cid_pa3"
                        value={value}
                        checked={formData.cid_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.cid_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            cid_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.cid_pa3) && formData.cid_pa3.length > 0
                  ? formData.cid_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cid_ec_a3"
                checked={formData.cid_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cid_c_a3"
                checked={formData.cid_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Paramétrage des référentiels salariés
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("pdr_pa3")}
              onMouseLeave={() => handleMouseLeave("pdr_pa3")}
            >
              {visiblePeriodicity["pdr_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="pdr_pa3"
                        value={value}
                        checked={formData.pdr_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.pdr_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            pdr_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.pdr_pa3) && formData.pdr_pa3.length > 0
                  ? formData.pdr_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="pdr_ec_a3"
                checked={formData.pdr_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="pdr_c_a3"
                checked={formData.pdr_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Reprise des bulletins de salaire antérieurs et cumul
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("rdb_pa3")}
              onMouseLeave={() => handleMouseLeave("rdb_pa3")}
            >
              {visiblePeriodicity["rdb_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="rdb_pa3"
                        value={value}
                        checked={formData.rdb_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.rdb_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            rdb_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.rdb_pa3) && formData.rdb_pa3.length > 0
                  ? formData.rdb_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="rdb_ec_a3"
                checked={formData.rdb_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="rdb_c_a3"
                checked={formData.rdb_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
          <tr style={{ fontWeight: "bold" }}>
            Traitement des bulletins de salaire
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Collecte et transmission par écrit <br /> (courriel, fax,
              courrier) des éléments de paie <br />
              (permanents + variables)
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("cetp_pa3")}
              onMouseLeave={() => handleMouseLeave("cetp_pa3")}
            >
              {visiblePeriodicity["cetp_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="cetp_pa3"
                        value={value}
                        checked={formData.cetp_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.cetp_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            cetp_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.cetp_pa3) &&
                formData.cetp_pa3.length > 0
                  ? formData.cetp_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cetp_ec_a3"
                checked={formData.cetp_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cetp_c_a3"
                checked={formData.cetp_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>

          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Établissement des bulletins de paie
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("edb_pa3")}
              onMouseLeave={() => handleMouseLeave("edb_pa3")}
            >
              {visiblePeriodicity["edb_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="edb_pa3"
                        value={value}
                        checked={formData.edb_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.edb_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            edb_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.edb_pa3) && formData.edb_pa3.length > 0
                  ? formData.edb_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="edb_ec_a3"
                checked={formData.edb_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="edb_c_a3"
                checked={formData.edb_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>

          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Établissement des règlements des salaires
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("edr_pa3")}
              onMouseLeave={() => handleMouseLeave("edr_pa3")}
            >
              {visiblePeriodicity["edr_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="edr_pa3"
                        value={value}
                        checked={formData.edr_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.edr_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            edr_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.edr_pa3) && formData.edr_pa3.length > 0
                  ? formData.edr_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="edr_ec_a3"
                checked={formData.edr_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="edr_c_a3"
                checked={formData.edr_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>

          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Contrôle des règlements des salaires
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("cdr_pa3")}
              onMouseLeave={() => handleMouseLeave("cdr_pa3")}
            >
              {visiblePeriodicity["cdr_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="cdr_pa3"
                        value={value}
                        checked={formData.cdr_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.cdr_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            cdr_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.cdr_pa3) && formData.cdr_pa3.length > 0
                  ? formData.cdr_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cdr_ec_a3"
                checked={formData.cdr_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cdr_c_a3"
                checked={formData.cdr_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>

          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Préparation de l’ordre de virement
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("pdl_pa3")}
              onMouseLeave={() => handleMouseLeave("pdl_pa3")}
            >
              {visiblePeriodicity["pdl_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="pdl_pa3"
                        value={value}
                        checked={formData.pdl_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.pdl_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            pdl_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.pdl_pa3) && formData.pdl_pa3.length > 0
                  ? formData.pdl_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="pdl_ec_a3"
                checked={formData.pdl_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="pdl_c_a3"
                checked={formData.pdl_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>

          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Edition du livre de paie récapitulatif
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("edl_pa3")}
              onMouseLeave={() => handleMouseLeave("edl_pa3")}
            >
              {visiblePeriodicity["edl_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="edl_pa3"
                        value={value}
                        checked={formData.edl_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.edl_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            edl_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.edl_pa3) && formData.edl_pa3.length > 0
                  ? formData.edl_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="edl_ec_a3"
                checked={formData.edl_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="edl_c_a3"
                checked={formData.edl_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>

          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Préparation des écritures comptables de paie
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("pde_pa3")}
              onMouseLeave={() => handleMouseLeave("pde_pa3")}
            >
              {visiblePeriodicity["pde_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="pde_pa3"
                        value={value}
                        checked={formData.pde_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.pde_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            pde_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.pde_pa3) && formData.pde_pa3.length > 0
                  ? formData.pde_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="pde_ec_a3"
                checked={formData.pde_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="pde_c_a3"
                checked={formData.pde_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
          <tr style={{ fontWeight: "bold" }}>
            Suivi administratif d’un salarié{" "}
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Suivi informatique des compteurs de congés payés
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("sid_pa3")}
              onMouseLeave={() => handleMouseLeave("sid_pa3")}
            >
              {visiblePeriodicity["sid_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="sid_pa3"
                        value={value}
                        checked={formData.sid_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.sid_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            sid_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.sid_pa3) && formData.sid_pa3.length > 0
                  ? formData.sid_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="sid_ec_a3"
                checked={formData.sid_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="sid_c_a3"
                checked={formData.sid_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
          <tr style={{ fontWeight: "bold" }}>Entrée du salarié</tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Paramétrage de la fiche « salarié »
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("pdls_pa3")}
              onMouseLeave={() => handleMouseLeave("pdls_pa3")}
            >
              {visiblePeriodicity["pdls_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="pdls_pa3"
                        value={value}
                        checked={formData.pdls_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.pdls_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            pdls_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.pdls_pa3) &&
                formData.pdls_pa3.length > 0
                  ? formData.pdls_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="pdls_ec_a3"
                checked={formData.pdls_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="pdls_c_a3"
                checked={formData.pdls_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Paramétrage du profil salarié sur le logiciel
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("pdp_pa3")}
              onMouseLeave={() => handleMouseLeave("pdp_pa3")}
            >
              {visiblePeriodicity["pdp_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="pdp_pa3"
                        value={value}
                        checked={formData.pdp_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.pdp_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            pdp_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.pdp_pa3) && formData.pdp_pa3.length > 0
                  ? formData.pdp_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="pdp_ec_a3"
                checked={formData.pdp_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="pdp_c_a3"
                checked={formData.pdp_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
          <tr style={{ fontWeight: "bold" }}>
            Déclarations sociales nominatives transmises par EDI
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Déclarations sociales nominatives (DSN) mensuelles
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("dsn_pa3")}
              onMouseLeave={() => handleMouseLeave("dsn_pa3")}
            >
              {visiblePeriodicity["dsn_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="dsn_pa3"
                        value={value}
                        checked={formData.dsn_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.dsn_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            dsn_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.dsn_pa3) && formData.dsn_pa3.length > 0
                  ? formData.dsn_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dsn_ec_a3"
                checked={formData.dsn_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dsn_c_a3"
                checked={formData.dsn_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
          <tr style={{ fontWeight: "bold" }}>
            Hors DSN : déclarations sociales et, le cas échéant, transmission de
            celles-ci
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Déclarations aux caisses de retraite complémentaires <br /> cadres
              et non cadres) (hors DSN)
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("dac_pa3")}
              onMouseLeave={() => handleMouseLeave("dac_pa3")}
            >
              {visiblePeriodicity["dac_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="dac_pa3"
                        value={value}
                        checked={formData.dac_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.dac_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            dac_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.dac_pa3) && formData.dac_pa3.length > 0
                  ? formData.dac_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dac_ec_a3"
                checked={formData.dac_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dac_c_a3"
                checked={formData.dac_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Déclarations aux organismes de retraite supplémentaire <br />{" "}
              et/ou de prévoyance complémentaire <br />
              (dont la complémentaire santé) à adhésion collective <br /> et
              obligatoire et/ou à adhésion individuelle et/ou facultative
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("dao_pa3")}
              onMouseLeave={() => handleMouseLeave("dao_pa3")}
            >
              {visiblePeriodicity["dao_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="dao_pa3"
                        value={value}
                        checked={formData.dao_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.dao_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            dao_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.dao_pa3) && formData.dao_pa3.length > 0
                  ? formData.dao_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dao_ec_a3"
                checked={formData.dao_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dao_c_a3"
                checked={formData.dao_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Déclarations à la caisse des congés payés, le cas échéant
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("dal_pa3")}
              onMouseLeave={() => handleMouseLeave("dal_pa3")}
            >
              {visiblePeriodicity["dal_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="dal_pa3"
                        value={value}
                        checked={formData.dal_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.dal_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            dal_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.dal_pa3) && formData.dal_pa3.length > 0
                  ? formData.dal_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dal_ec_a3"
                checked={formData.dal_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dal_c_a3"
                checked={formData.dal_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Déclaration à la médecine du travail
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("dalm_pa3")}
              onMouseLeave={() => handleMouseLeave("dalm_pa3")}
            >
              {visiblePeriodicity["dalm_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="dalm_pa3"
                        value={value}
                        checked={formData.dalm_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.dalm_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            dalm_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.dalm_pa3) &&
                formData.dalm_pa3.length > 0
                  ? formData.dalm_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dalm_ec_a3"
                checked={formData.dalm_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dalm_c_a3"
                checked={formData.dalm_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Déclarations annuelles fiscales, le cas échéant (hors DSN) <br />
              Taxe sur les salaires
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("daf_pa3")}
              onMouseLeave={() => handleMouseLeave("daf_pa3")}
            >
              {visiblePeriodicity["daf_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="daf_pa3"
                        value={value}
                        checked={formData.daf_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.daf_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            daf_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.daf_pa3) && formData.daf_pa3.length > 0
                  ? formData.daf_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="daf_ec_a3"
                checked={formData.daf_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="daf_c_a3"
                checked={formData.daf_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              DADS jusqu’à son remplacement par la DSN
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("dads_pa3")}
              onMouseLeave={() => handleMouseLeave("dads_pa3")}
            >
              {visiblePeriodicity["dads_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="dads_pa3"
                        value={value}
                        checked={formData.dads_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.dads_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            dads_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.dads_pa3) &&
                formData.dads_pa3.length > 0
                  ? formData.dads_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dads_ec_a3"
                checked={formData.dads_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dads_c_a3"
                checked={formData.dads_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Télétransmission des données sociales aux <br /> organismes
              sociaux (hors DSN)
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("tdd_pa3")}
              onMouseLeave={() => handleMouseLeave("tdd_pa3")}
            >
              {visiblePeriodicity["tdd_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="tdd_pa3"
                        value={value}
                        checked={formData.tdd_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.tdd_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            tdd_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.tdd_pa3) && formData.tdd_pa3.length > 0
                  ? formData.tdd_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="tdd_ec_a3"
                checked={formData.tdd_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="tdd_c_a3"
                checked={formData.tdd_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
          <tr style={{ fontWeight: "bold" }}>Obligations réglementaires</tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Remise aux salariés d’une notice d’information sur la DSN
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("ras_pa3")}
              onMouseLeave={() => handleMouseLeave("ras_pa3")}
            >
              {visiblePeriodicity["ras_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="ras_pa3"
                        value={value}
                        checked={formData.ras_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.ras_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            ras_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.ras_pa3) && formData.ras_pa3.length > 0
                  ? formData.ras_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="ras_ec_a3"
                checked={formData.ras_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="ras_c_a3"
                checked={formData.ras_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Tenue des dossiers individuels des salariés
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("tddi_pa3")}
              onMouseLeave={() => handleMouseLeave("tddi_pa3")}
            >
              {visiblePeriodicity["tddi_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="tddi_pa3"
                        value={value}
                        checked={formData.tddi_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.tddi_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            tddi_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.tddi_pa3) &&
                formData.tddi_pa3.length > 0
                  ? formData.tddi_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="tddi_ec_a3"
                checked={formData.tddi_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="tddi_c_a3"
                checked={formData.tddi_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Tenue du registre unique du personnel <br /> (entrées et sorties,
              travailleurs de moins de 18 ans, <br />
              travailleurs à domicile, travailleurs étrangers, stagiaires)
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("tdru_pa3")}
              onMouseLeave={() => handleMouseLeave("tdru_pa3")}
            >
              {visiblePeriodicity["tdru_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="tdru_pa3"
                        value={value}
                        checked={formData.tdru_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.tdru_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            tdru_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.tdru_pa3) &&
                formData.tdru_pa3.length > 0
                  ? formData.tdru_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="tdru_ec_a3"
                checked={formData.tdru_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="tdru_c_a3"
                checked={formData.tdru_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Tenue des décomptes de la durée du travail
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("tddd_pa3")}
              onMouseLeave={() => handleMouseLeave("tddd_pa3")}
            >
              {visiblePeriodicity["tddd_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="tddd_pa3"
                        value={value}
                        checked={formData.tddd_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.tddd_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            tddd_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.tddd_pa3) &&
                formData.tddd_pa3.length > 0
                  ? formData.tddd_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="tddd_ec_a3"
                checked={formData.tddd_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="tddd_c_a3"
                checked={formData.tddd_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Établissement et mise à jour du document unique <br />
              sur l’évaluation des risques
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("eema_pa3")}
              onMouseLeave={() => handleMouseLeave("eema_pa3")}
            >
              {visiblePeriodicity["eema_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="eema_pa3"
                        value={value}
                        checked={formData.eema_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.eema_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            eema_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.eema_pa3) &&
                formData.eema_pa3.length > 0
                  ? formData.eema_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="eema_ec_a3"
                checked={formData.eema_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="eema_c_a3"
                checked={formData.eema_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Tenue du registre des observations et mise en demeure
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("tdrd_pa3")}
              onMouseLeave={() => handleMouseLeave("tdrd_pa3")}
            >
              {visiblePeriodicity["tdrd_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="tdrd_pa3"
                        value={value}
                        checked={formData.tdrd_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.tdrd_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            tdrd_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.tdrd_pa3) &&
                formData.tdrd_pa3.length > 0
                  ? formData.tdrd_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="tdrd_ec_a3"
                checked={formData.tdrd_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="tdrd_c_a3"
                checked={formData.tdrd_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Tenue du registre médical
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("tdrm_pa3")}
              onMouseLeave={() => handleMouseLeave("tdrm_pa3")}
            >
              {visiblePeriodicity["tdrm_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="tdrm_pa3"
                        value={value}
                        checked={formData.tdrm_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.tdrm_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            tdrm_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.tdrm_pa3) &&
                formData.tdrm_pa3.length > 0
                  ? formData.tdrm_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="tdrm_ec_a3"
                checked={formData.tdrm_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="tdrm_c_a3"
                checked={formData.tdrm_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Tenue du registre d'hygiène et de sécurité
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("tdrde_pa3")}
              onMouseLeave={() => handleMouseLeave("tdrde_pa3")}
            >
              {visiblePeriodicity["tdrde_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="tdrde_pa3"
                        value={value}
                        checked={formData.tdrde_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.tdrde_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            tdrde_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.tdrde_pa3) &&
                formData.tdrde_pa3.length > 0
                  ? formData.tdrde_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="tdrde_ec_a3"
                checked={formData.tdrde_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="tdrde_c_a3"
                checked={formData.tdrde_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Etablissement et tenue de la fiche de prévention des expositions
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("eetd_pa3")}
              onMouseLeave={() => handleMouseLeave("eetd_pa3")}
            >
              {visiblePeriodicity["eetd_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="eetd_pa3"
                        value={value}
                        checked={formData.eetd_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.eetd_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            eetd_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.eetd_pa3) &&
                formData.eetd_pa3.length > 0
                  ? formData.eetd_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="eetd_ec_a3"
                checked={formData.eetd_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="eetd_c_a3"
                checked={formData.eetd_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Mise en place et gestion du compte personnel <br /> de prévention
              de la pénibilité
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("mep_pa3")}
              onMouseLeave={() => handleMouseLeave("mep_pa3")}
            >
              {visiblePeriodicity["mep_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="mep_pa3"
                        value={value}
                        checked={formData.mep_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.mep_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            mep_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.mep_pa3) && formData.mep_pa3.length > 0
                  ? formData.mep_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="mep_ec_a3"
                checked={formData.mep_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="mep_c_a3"
                checked={formData.mep_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Mise en place et suivi des contrats de prévoyance <br /> et de
              complémentaire santé
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("mepe_pa3")}
              onMouseLeave={() => handleMouseLeave("mepe_pa3")}
            >
              {visiblePeriodicity["mepe_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="mepe_pa3"
                        value={value}
                        checked={formData.mepe_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.mepe_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            mepe_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.mepe_pa3) &&
                formData.mepe_pa3.length > 0
                  ? formData.mepe_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="mepe_ec_a3"
                checked={formData.mepe_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="mepe_c_a3"
                checked={formData.mepe_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Etablissement de l’attestation de stage à remettre <br />
              aux stagiaires en entreprise
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("edld_pa3")}
              onMouseLeave={() => handleMouseLeave("edld_pa3")}
            >
              {visiblePeriodicity["edld_pa3"] && (
                <div>
                  {["D", "M", "T", "A", "P"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="edld_pa3"
                        value={value}
                        checked={formData.edld_pa3?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.edld_pa3 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            edld_pa3: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.edld_pa3) &&
                formData.edld_pa3.length > 0
                  ? formData.edld_pa3.join("/")
                  : "Aucune"}
              </p>
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="edld_ec_a3"
                checked={formData.edld_ec_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>

            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="edld_c_a3"
                checked={formData.edld_c_a3 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default TableauAnnexe3;
